import React from 'react';
import PropTypes from 'prop-types';

import {
  Checkbox,
  Form,
  Input,
  Modal,
  Switch } from 'antd';

import { withTranslation } from 'react-i18next';

import QuillEditor from '@components/QuillEditor'
import {
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';


class UpdateSettingsForm extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    confirmLoading: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    ownership: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  }

  static defaultProps = {
    visible: false,
    confirmLoading: false,
  }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.props.form.setFieldsValue({
      invoice_remarks: value,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible && !this.props.visible) {
      this.props.form.resetFields();
      return
    }
  }

  render() {
    const { visible, onOk, onCancel, confirmLoading, form, ownership } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };

    return (
      <Modal
        visible={ visible }
        width="70%"
        title={ this.props.t("OwnershipDetailSections.Settings.actions.UpdateSettings") }
        okText={ this.props.t("actions.Submit") }
        onCancel={ onCancel }
        onOk={ onOk }
        confirmLoading={ confirmLoading }
      >
        { this.props.children }
        <Form form={this.props.form} layout="horizontal">
          <Form.Item
            hasFeedback
            label={ this.props.t("Properties.PropertyName")}
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="name" rules={[
                { required: true, message: 'Please input a property name' },
              ]} initialValue={ownership.name}>
            <Input />
          </Form.Item>
          { false && (<div>
          <Form.Item
            label="Send Invoices"
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="send_invoices" initialValue={ownership.send_invoices || false} valuePropName="checked">
            <Switch
                checkedChildren={<CheckOutlined/>}
                unCheckedChildren={<CloseOutlined/>}
              />
          </Form.Item>
          <Form.Item
            label="Send Payment Reminders"
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="send_payment_reminders" initialValue={ownership.send_payment_reminders || false} valuePropName="checked">
            <Switch
                checkedChildren={<CheckOutlined/>}
                unCheckedChildren={<CloseOutlined/>}
              />
          </Form.Item>
          <Form.Item
            label="Send Receipts"
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="send_receipts" initialValue={ownership.send_receipts || false} valuePropName="checked">
            <Switch
                checkedChildren={<CheckOutlined/>}
                unCheckedChildren={<CloseOutlined/>}
              />
          </Form.Item>
          </div>)}
          <Form.Item
            label={ this.props.t("OwnershipDetailSections.Settings.BankName") }
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="bank_name" initialValue={ownership.bank_name || ""}>
            <Input />
          </Form.Item>
          <Form.Item
            label={ this.props.t("OwnershipDetailSections.Settings.BankAddress") }
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="bank_address" initialValue={ownership.bank_address || ""}>
            <Input />
          </Form.Item>
          <Form.Item
            label={ this.props.t("OwnershipDetailSections.Settings.BankSwift") }
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="bank_swift_code" initialValue={ownership.bank_swift_code || ""}>
            <Input />
          </Form.Item>
          <Form.Item
            label={ this.props.t("OwnershipDetailSections.Settings.BankAccountName") }
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="bank_account_name" initialValue={ownership.bank_account_name || ""}>
            <Input />
          </Form.Item>
          <Form.Item
            label={ this.props.t("OwnershipDetailSections.Settings.BankAccountNumber") }
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="bank_account_number" initialValue={ownership.bank_account_number || ""}>
            <Input />
          </Form.Item>
          <Form.Item
            label={ this.props.t("OwnershipDetailSections.Settings.IncludeSignature")}
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="include_signature_for_autogenerated" initialValue={ownership.include_signature_for_autogenerated}>
            <Checkbox.Group
                options={[
                  { label: this.props.t("OwnershipDetailSections.Settings.IncludeSignatureDebitNote"), value: 'Invoice' },
                  { label: this.props.t("OwnershipDetailSections.Settings.IncludeSignatureReceipt"), value: 'Receipt' },
                ]}
              />
          </Form.Item>
          <Form.Item
            label={ this.props.t("OwnershipDetailSections.Settings.DebitNoteFormat") }
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="invoice_number_generator" initialValue={ownership.invoice_number_generator || ""}>
            <Input />
          </Form.Item>
          <Form.Item
            label={ this.props.t("OwnershipDetailSections.Settings.DebitNoteRemarks") }
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
           name="invoice_remarks" initialValue={ownership.invoice_remarks || ""}>
            <Input.TextArea style={{ display: 'none' }} />
            <QuillEditor
              value={ this.props.form.getFieldValue('invoice_remarks') }
              onChange={ this.handleChange }
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const WrappedUpdateSettingsForm = (props) => {
  const [form] = Form.useForm();
  const { formRef, ...restProps } = props;
  if (formRef) formRef(form);
  return <UpdateSettingsForm {...restProps} form={form} />;
};
export default withTranslation('common')(WrappedUpdateSettingsForm);
